/* eslint-disable */
import CharaBase from "../../common/CharaBase";
import Helper from "../../common/Helper";

class CharaPurpose extends CharaBase {
  constructor(scene) {
    super(scene);

    this.mesh = this.scene.getNodeByID("Planet_root");

    this.moon = this.scene.getMeshByID(Helper.getPlanetName(0));
    this.mars = this.scene.getMeshByID(Helper.getPlanetName(1));
    this.venus = this.scene.getMeshByID(Helper.getPlanetName(2));
    this.jupiter = this.scene.getMeshByID(Helper.getPlanetName(3));
    this.saturn = this.scene.getMeshByID(Helper.getPlanetName(4));

    this.moon.position.y = Helper.getPlanetPosition(0);
    this.mars.position.y = Helper.getPlanetPosition(1);
    this.venus.position.y = Helper.getPlanetPosition(2);
    this.jupiter.position.y = Helper.getPlanetPosition(3);
    this.saturn.position.y = Helper.getPlanetPosition(4);
  }

  setPurpose(number) {
    this.moon.position.z = -20;
    this.mars.position.z = -100;
    this.venus.position.z = -60;
    this.jupiter.position.z = -280;
    this.saturn.position.z = -120;

    switch (number) {
      case 0:
        this.moon.position.z = 0;
        break;
      case 1:
        this.mars.position.z = 0;
        break;
      case 2:
        this.venus.position.z = 0;
        break;
      case 3:
        this.jupiter.position.z = 0;
        break;
      case 4:
        this.saturn.position.z = 0;
        break;
    }
  }
}
export default CharaPurpose;
